import { useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import SingleLineInput from 'src/components/form/SingleLineInput'
import { H2 } from 'src/styles/Typography'
import grabColor from 'src/utils/grabColor'
import { element } from 'prop-types'

function MedicareDay({
  value,
  name,
  onChange,
  gotoNextStep,
  design = 'a',
  ...restInputProps
}) {
  const inputRef = useRef(null)
  const [yearLast2Digits, setYearLast2Digits] = useState(
    value?.length === 4 ? value.slice(-2) : '',
  )

  // useEffect(() => {
  //   setTimeout(function () {
  //     document.getElementById('year').focus()
  //   }, 50)
  // }, [])

  const handleSetYearLAst2Digits = (e) => {
    setYearLast2Digits(e.target.value)

    const fullYear = `19${e.target.value}`

    if (fullYear.length === 4) {
      onChange({ target: { name: 'year', value: fullYear } })
      gotoNextStep({ target: { name: 'year', value: fullYear } }, false, false)
    }
  }

  return (
    <div>
      <Wrapper design={design}>
        <H2>19</H2>
        <div>
          <SingleLineInput
            name={name}
            value={yearLast2Digits}
            minLength={1}
            maxLength={2}
            size={2}
            {...restInputProps}
            onChange={handleSetYearLAst2Digits}
          />
        </div>
      </Wrapper>
    </div>
  )
}

const Wrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  ${H2} {
    margin: 1.6rem 0 0;
    vertical-align: middle;
  }

  // b design
  ${({ design }) =>
    design === 'b' &&
    `
     margin-top: -24px;
    `}

  @media (max-width: ${({ theme }) => theme.breakpoints.desktop}) {
    ${({ design }) =>
      design === 'b' &&
      `
    margin-top: -10px;
    ${H2} {
      margin: 1.2rem 0 0;
    }
    `}
  }
`

export default MedicareDay
